export enum StoreRoleEnum {
    Owner = 'Owner',
    Admin = 'Admin',
    Manager = 'Manager',
    Employee = 'Employee',
  }